<script setup>

</script>

<template>
  <div class="w-full">
    <h1>Clorox Bleach</h1>
    <embed src="/pdf/wd-40-multi-use-product-aerosol-low-voc-sds-us-ghs.pdf" width="1440px" height="900px" >
  </div>
</template>

<style>

</style>